module.exports = __webpack_public_path__ + "static/media/toll2.ef02d47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/journey/toll2.png
// module id = 316
// module chunks = 0